import { TFunction } from 'i18next';
import { DistanceUnit } from '@bringg/types';

export const KM_TO_MILES_MULTIPLIER = 0.621371;
const METERS_IN_KM = 1000;

export const isImperialUnitsCountry = (countryCode: string): boolean => countryCode === 'us' || countryCode === 'uk';

export const kmToMiles = (km: number): number => km * KM_TO_MILES_MULTIPLIER;

export const getDistanceUnit = (countryCode: string): DistanceUnit =>
	isImperialUnitsCountry(countryCode) ? DistanceUnit.Miles : DistanceUnit.Kilometers;

export const getLocalizedDistanceMessage = (distanceInMeters: number, countryCode: string, t: TFunction): string => {
	const distanceFixed = getLocalizedDistance(distanceInMeters / METERS_IN_KM, countryCode);
	const unit = getLocalizedDistanceUnitLabel(countryCode, t);

	return `${distanceFixed} ${unit}`;
};

export const getLocalizedDistance = (distanceInKm: number, countryCode: string): string => {
	const distance = isImperialUnitsCountry(countryCode) ? kmToMiles(distanceInKm) : distanceInKm;

	return distance.toFixed(1);
};

export const getLocalizedDistanceUnitLabel = (countryCode: string, t: TFunction): string => {
	return t(isImperialUnitsCountry(countryCode) ? 'ORDER.MILES' : 'ORDER.KM');
};
